// GENERATED by scripts/gen-app-controls.ts from apps/web/src. Do not edit: run `bun scripts/gen-app-controls.ts`.
// The only names a tap may carry (core appevents.ts E2): testIDs, testID prefixes and button labels a developer wrote.
import type { RouteGates } from "../appevents.ts";


/** The app's route patterns (App.tsx), for core webScreen: an address is measured only as one of these. */
export const WEB_ROUTES: readonly string[] = [
  "",
  "activity",
  "activity/:employeeId",
  "admin/compliance",
  "admin/data",
  "admin/waitlist",
  "allergen-menu/:orgId/:locationId",
  "allergens/menu",
  "allergens/photo",
  "allergens/setup",
  "allergens/setup/:id",
  "allergy-order",
  "audit-trail",
  "billing",
  "billing/back",
  "billing/cancel",
  "billing/done",
  "billing/start",
  "carrying",
  "check-in",
  "clean",
  "content",
  "do",
  "do/fix/:entryId",
  "f/:token",
  "fix/:item",
  "food",
  "food/act/:id",
  "food/cooling",
  "food/label",
  "google/callback",
  "guest-notes",
  "guide/:token",
  "have",
  "health",
  "health-agreement",
  "home-tune",
  "insights",
  "inspection",
  "invite-business",
  "invite/:inviteId",
  "join",
  "kids",
  "kits",
  "kits/:kitId",
  "learn",
  "learn/how/:templateId",
  "learn/lesson/:lessonId",
  "learn/library",
  "learn/library/:topicId",
  "learn/playbook",
  "learn/sign/:ackId",
  "learn/spills",
  "learn/spills/:slug",
  "learn/stains",
  "learn/stains/:slug",
  "learn/surfaces",
  "learn/surfaces/:surfaceId",
  "me",
  "me/notifications",
  "messages",
  "more",
  "objects",
  "objects/:id",
  "objects/guide",
  "objects/run/:phase",
  "objects/states",
  "open",
  "order",
  "ownership/accept",
  "pantry",
  "paper",
  "paper/review",
  "people",
  "people/:id",
  "people/add",
  "people/permissions",
  "places",
  "places/:id",
  "playbook",
  "points",
  "prep",
  "prep/:orgId",
  "print",
  "privacy",
  "products",
  "prove",
  "reach",
  "recall",
  "report",
  "rooms",
  "rooms/ai-check",
  "rooms/check/:room",
  "rooms/check/:room/contents",
  "rooms/guide/:sopId",
  "rooms/where",
  "s/:code",
  "s/about",
  "see/:token",
  "settings",
  "settings/locations/new",
  "setup",
  "signs",
  "snap",
  "snap/review",
  "start/have",
  "start/open",
  "start/ready",
  "start/stage",
  "steps/:procedureId",
  "supplies",
  "supplies/buy",
  "supplies/check",
  "supplies/item/:key",
  "supplies/kit",
  "supplies/setup",
  "team",
  "team/day",
  "team/logs",
  "today",
  "walk",
  "walk/review",
  "welcome",
  "workspaces",
  "workspaces/new/business",
  "workspaces/new/home",
];

/** Who may open each route (App.tsx RequireRole / RequireSwitch), for the app search (core appsearch.ts). */
export const WEB_ROUTE_GATES: Readonly<Record<string, RouteGates>> = {
  "": { business: {}, home: {} },
  "activity": { business: {} },
  "activity/:employeeId": { business: { min: "manager" } },
  "admin/compliance": { business: {} },
  "admin/data": { business: {}, home: {} },
  "admin/waitlist": { business: {} },
  "allergen-menu/:orgId/:locationId": { business: {} },
  "allergens/menu": { business: { min: "manager" } },
  "allergens/photo": { business: { min: "admin" } },
  "allergens/setup": { business: { min: "admin" } },
  "allergens/setup/:id": { business: { min: "admin" } },
  "allergy-order": { business: {} },
  "audit-trail": { business: { min: "manager" } },
  "billing": { business: { min: "manager", sw: "billing" }, home: { min: "owner" } },
  "billing/back": { business: { min: "manager", sw: "billing" }, home: { min: "owner" } },
  "billing/cancel": { business: { min: "manager", sw: "billing" }, home: { min: "owner" } },
  "billing/done": { business: { min: "manager", sw: "billing" }, home: { min: "owner" } },
  "billing/start": { business: { min: "manager", sw: "billing" }, home: { min: "owner" } },
  "carrying": { business: {} },
  "check-in": { business: {} },
  "clean": { business: {}, home: {} },
  "content": { business: {}, home: {} },
  "do": { business: {} },
  "do/fix/:entryId": { business: {} },
  "f/:token": { business: {} },
  "fix/:item": { business: {} },
  "food": { business: {}, home: {} },
  "food/act/:id": { business: {} },
  "food/cooling": { business: {} },
  "food/label": { business: {}, home: {} },
  "google/callback": { business: { min: "admin" } },
  "guest-notes": { business: {} },
  "guide/:token": { business: {} },
  "have": { home: {} },
  "health": { business: { min: "manager" }, home: {} },
  "health-agreement": { business: { min: "manager" } },
  "home-tune": { home: {} },
  "insights": { business: { min: "manager" } },
  "inspection": { business: {} },
  "invite-business": { business: {}, home: {} },
  "invite/:inviteId": { business: {} },
  "join": { business: {} },
  "kids": { home: {} },
  "kits": { business: {}, home: {} },
  "kits/:kitId": { business: {}, home: {} },
  "learn": { business: {} },
  "learn/how/:templateId": { business: {} },
  "learn/lesson/:lessonId": { business: {} },
  "learn/library": { business: {} },
  "learn/library/:topicId": { business: {} },
  "learn/playbook": { business: {} },
  "learn/sign/:ackId": { business: {} },
  "learn/spills": { business: {} },
  "learn/spills/:slug": { business: {} },
  "learn/stains": { business: {} },
  "learn/stains/:slug": { business: {} },
  "learn/surfaces": { business: {} },
  "learn/surfaces/:surfaceId": { business: {} },
  "me": { business: {} },
  "me/notifications": { business: {} },
  "messages": { business: {}, home: {} },
  "more": { business: {}, home: {} },
  "objects": { business: {}, home: {} },
  "objects/:id": { business: {}, home: {} },
  "objects/guide": { business: {}, home: {} },
  "objects/run/:phase": { business: {}, home: {} },
  "objects/states": { business: { min: "manager" }, home: {} },
  "open": { business: { min: "manager" } },
  "order": { business: {} },
  "ownership/accept": { business: {} },
  "pantry": { home: {} },
  "paper": { business: {} },
  "paper/review": { business: { min: "manager" } },
  "people": { business: { min: "manager" } },
  "people/:id": { business: { min: "manager" } },
  "people/add": { business: { min: "manager" } },
  "people/permissions": { business: { min: "manager" } },
  "places": { business: {} },
  "places/:id": { business: {} },
  "playbook": { business: {} },
  "points": { business: {} },
  "prep": { business: {}, home: {} },
  "prep/:orgId": { business: {}, home: {} },
  "print": { business: {} },
  "privacy": { business: {}, home: {} },
  "products": { business: {}, home: {} },
  "prove": { business: { min: "manager" } },
  "reach": { business: {} },
  "recall": { business: { min: "manager" } },
  "report": { business: {} },
  "rooms": { business: {}, home: {} },
  "rooms/ai-check": { business: {} },
  "rooms/check/:room": { business: {}, home: {} },
  "rooms/check/:room/contents": { business: {}, home: {} },
  "rooms/guide/:sopId": { home: {} },
  "rooms/where": { home: {} },
  "s/:code": { business: {} },
  "s/about": { business: {} },
  "see/:token": { business: {} },
  "settings": { business: { min: "manager", sw: "settings" } },
  "settings/locations/new": { business: { min: "manager", sw: "settings" } },
  "setup": { business: {} },
  "signs": { business: { min: "manager" } },
  "snap": { business: {} },
  "snap/review": { business: {} },
  "start/have": { business: { min: "manager" }, home: {} },
  "start/open": { business: { min: "admin" } },
  "start/ready": { business: {} },
  "start/stage": { business: { min: "admin" }, home: {} },
  "steps/:procedureId": { business: {} },
  "supplies": { business: {} },
  "supplies/buy": { business: {} },
  "supplies/check": { business: {} },
  "supplies/item/:key": { business: {} },
  "supplies/kit": { business: {} },
  "supplies/setup": { business: { min: "manager" } },
  "team": { business: { min: "manager" } },
  "team/day": { business: {} },
  "team/logs": { business: { min: "manager" } },
  "today": { business: {} },
  "walk": { business: {} },
  "walk/review": { business: {} },
  "welcome": { business: {} },
  "workspaces": { business: {}, home: {} },
  "workspaces/new/business": { business: {}, home: {} },
  "workspaces/new/home": { business: {} },
};
